import { c as _c } from "react/compiler-runtime";
import type { FilterValue } from "@repo/design-system/types/filter";
import type { Option } from "@repo/design-system/types/filtermenu";
import { cn } from "@repo/design-system/utils/cn";
import { X } from "lucide-react";
import { Badge } from "~/components/ui/badge-eon";
const getTranslateClass = (length: number) => {
  if (length <= 10) {
    return "hover:-translate-x-4";
  }
  if (length <= 20) {
    return "hover:-translate-x-12";
  }
  if (length <= 30) {
    return "hover:-translate-x-28";
  }
  return "hover:-translate-x-40";
};
export function OptionBadge(t0) {
  const $ = _c(29);
  const {
    option,
    onValueRemove,
    variant,
    capped: t1
  } = t0;
  const capped = t1 === undefined ? true : t1;
  const labelLength = option.label.length;
  const t2 = capped && "max-w-22";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("hide-scrollbar mr-1 mb-1 px-1", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = option.value;
  let t5;
  if ($[2] !== capped || $[3] !== labelLength) {
    t5 = capped && getTranslateClass(labelLength);
    $[2] = capped;
    $[3] = labelLength;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t5) {
    t6 = cn("w-full transition-discrete duration-1000", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== option.label || $[8] !== t6) {
    t7 = <p className={t6}>{option.label}</p>;
    $[7] = option.label;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== capped) {
    t8 = capped && <div className="pointer-events-none absolute top-0 right-0 h-full w-2" />;
    $[10] = capped;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="hide-scrollbar relative overflow-y-auto" tabIndex={-1}>{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  let t11;
  if ($[15] !== onValueRemove || $[16] !== option.value) {
    t10 = async e => {
      e.preventDefault();
      e.stopPropagation();
      await onValueRemove(option.value);
    };
    t11 = async e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      await onValueRemove(option.value);
    };
    $[15] = onValueRemove;
    $[16] = option.value;
    $[17] = t10;
    $[18] = t11;
  } else {
    t10 = $[17];
    t11 = $[18];
  }
  let t12;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <X className="size-4 hover:text-black" />;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t10 || $[21] !== t11) {
    t13 = <slot className="ml-1 cursor-pointer rounded-full outline-none ring-offset-background focus:ring-2 focus:ring-ring focus:ring-offset-2" onClick={t10} onKeyDown={t11} role="button">{t12}</slot>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== option.value || $[24] !== t13 || $[25] !== t3 || $[26] !== t9 || $[27] !== variant) {
    t14 = <Badge className={t3} key={t4} variant={variant}>{t9}{t13}</Badge>;
    $[23] = option.value;
    $[24] = t13;
    $[25] = t3;
    $[26] = t9;
    $[27] = variant;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}